// @ts-nocheck
import React from 'react';
import { ApplyPluginsType, dynamic } from '/data/jenkins/workspace/aplus_tiger_copyright_complaint7c3c60c3-a5e2-4c8e-a871-1459b911c7e4_tiger-platform_udb_copyright_complaint_71743_nodejs_prod/node_modules/.pnpm/@umijs+runtime@3.5.32_react@16.14.0/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';
import LoadingComponent from '@/Loading';

export function getRoutes() {
  const routes = [
  {
    "path": "/detail.html",
    "exact": true,
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__detail__index' */'@/pages/detail/index.tsx'), loading: LoadingComponent})
  },
  {
    "path": "/index.html",
    "exact": true,
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__index__index' */'@/pages/index/index.tsx'), loading: LoadingComponent})
  },
  {
    "path": "/",
    "exact": true,
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__index__index' */'@/pages/index/index.tsx'), loading: LoadingComponent})
  },
  {
    "path": "/list.html",
    "exact": true,
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__list__index' */'@/pages/list/index.tsx'), loading: LoadingComponent})
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
